import { baseUrl } from '../config/clientsConfig'
import axios from "axios";

const ReportService ={
  fetchSittingReport : (startDate,endDate) => axios.get(`${baseUrl}/sitting-report?startDate=${startDate}&endDate=${endDate}`),
  fetchAfterSittingReport : (startDate,endDate) => axios.get(`${baseUrl}/aftersitting-report?startDate=${startDate}&endDate=${endDate}`),
  fetchBookingReport: (startDate,endDate) => axios.get(`${baseUrl}/booking-report?startDate=${startDate}&endDate=${endDate}`),
  fegtchAgreementReport: (startDate, endDate )=> axios.get(`${baseUrl}/overall-agreement-report?startDate=${startDate}&endDate=${endDate}`),
  fetchSiteVisitReport: (startDate, endDate) => axios.get (`${baseUrl}/sitevisit-report?startDate=${startDate}&endDate=${endDate}`),
  fetchFullyRegisteredReport :  (startDate, endDate) => axios.get (`${baseUrl}/fullyregistered-report?startDate=${startDate}&endDate=${endDate}`),
  fetchAfterSitevisitReport : (startDate, endDate) => axios.get (`${baseUrl}/aftersitevisit-report?startDate=${startDate}&endDate=${endDate}`),
  fetchAdvanceAmountReport : (startDate, endDate) => axios.get (`${baseUrl}/advance-amount-report?startDate=${startDate}&endDate=${endDate}`),
  fetchRegistrationProgressReport : (startDate, endDate) => axios.get (`${baseUrl}/registration-progress-report?startDate=${startDate}&endDate=${endDate}`),
  fetchDealLostBeforeReport : (startDate, endDate) => axios.get (`${baseUrl}/deal-lost-before-booking-report?startDate=${startDate}&endDate=${endDate}`),
  fetchDealLostAfterReport : (startDate, endDate) => axios.get (`${baseUrl}/deal-lost-after-booking-report?startDate=${startDate}&endDate=${endDate}`),



  // Lead Report Service

  fetchLeadReport : (startDate,endDate) => axios.get(`${baseUrl}/lead-report?startDate=${startDate}&endDate=${endDate}`),
  
}

 export default ReportService;